// src/pages/ChangePasswordPage.js
// Shown (by AppRouter) when a logged-in vendor / mall admin has mustChangePassword set,
// i.e. after a super admin set a temporary password for them.

import React, { useState } from 'react';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';

export default function ChangePasswordPage() {
  const { role, updateUser, logout } = useAuth();
  const [password, setPassword] = useState('');
  const [confirm,  setConfirm]  = useState('');
  const [error,    setError]    = useState('');
  const [loading,  setLoading]  = useState(false);

  const endpoint = role === 'MALL_ADMIN' ? '/mall/change-password' : '/auth/change-password';

  const handle = async () => {
    if (password.length < 8) return setError('Password must be at least 8 characters.');
    if (password !== confirm) return setError('Passwords do not match.');
    setLoading(true); setError('');
    try {
      await api.post(endpoint, { newPassword: password });
      updateUser({ mustChangePassword: false }); // AppRouter then shows the dashboard
    } catch (err) {
      setError(err.response?.data?.error || 'Could not update password.');
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:'var(--bg)' }}>
      <div style={{ background:'var(--bg2)', border:'1px solid var(--border)', borderRadius:'var(--radius)', padding:40, width:400 }}>
        <div style={{ textAlign:'center', marginBottom:28 }}>
          <div style={{ fontSize:32, marginBottom:8 }}>🔐</div>
          <div style={{ fontSize:20, fontWeight:700, color:'var(--accent)' }}>Change Your Password</div>
          <div style={{ fontSize:13, color:'var(--text2)', marginTop:4 }}>
            You signed in with a temporary password. Choose a new one to continue.
          </div>
        </div>

        <div style={{ marginBottom:16 }}>
          <div className="section-label" style={{ marginBottom:6 }}>New password</div>
          <input type="password" value={password} onChange={e => setPassword(e.target.value)}
            placeholder="At least 8 characters" autoFocus />
        </div>
        <div style={{ marginBottom:24 }}>
          <div className="section-label" style={{ marginBottom:6 }}>Confirm password</div>
          <input type="password" value={confirm} onChange={e => setConfirm(e.target.value)}
            placeholder="Repeat your password" onKeyDown={e => e.key === 'Enter' && handle()} />
        </div>

        {error && <div style={{ color:'var(--red)', fontSize:13, marginBottom:14, textAlign:'center' }}>{error}</div>}

        <button className="btn btn-primary" style={{ width:'100%', padding:13 }} onClick={handle} disabled={loading}>
          {loading ? 'Updating...' : 'Update Password'}
        </button>
        <button className="btn btn-ghost" style={{ width:'100%', marginTop:10 }} onClick={logout}>Log out</button>
      </div>
    </div>
  );
}
